import axios from "axios";
import fingerprint2 from "@fingerprintjs/fingerprintjs";

import { apiConfig, iframeConfig, timingConfig } from "../config";
import { storageHelper } from "../helper";

export default {
	authorizeEventOrigin(origin) {
		//TODO allow http && https
		return Object.keys(iframeConfig.routes).find(key => iframeConfig.routes[key] === origin);
	},
	authenticateApiKey: async (apiKey) => {
		const result = await axios.get(apiConfig.checkApiKey, { headers: { Authorization: `Bearer ${apiKey}` } });

		if (result.status !== 200) {
			throw new Error(result);
		}
	},
	identifyContact: async ({ apiKey, data }) => {
		const identityId = storageHelper.getIdentity();

		if (identityId) {
			const result = await axios.get(apiConfig.verifyIdentity.replace(":id", identityId), {
				headers: { Authorization: `Bearer ${apiKey}` },
			});

			if (result && result.data.success) {
				return result.data.data;
			}
		}

		// const fingerprint = await getFingerprint();
		const result = await axios.post(
			apiConfig.createIdentity,
			data, //{ ...data, fingerprint },
			{ headers: { Authorization: `Bearer ${apiKey}` } },
		);

		if (!result || !result.data.success) {
			return undefined;
		}

		storageHelper.setIdentity(result.data.data.id);

		return result.data.data;
	},
	getFingerprint,
}

async function getFingerprint() {
	return new Promise((resolve) => {
		setTimeout(async () => { //necessary to keep fingerprint same through reload
			const config = {
				excludes: {
					userAgent: true,
					adBlock: false,
					plugins: true,
					fonts: true,
					excludeAdBlock: true,
					hardwareConcurrency: true,
					enumerateDevices: true,
					audio: true,
				},
			};
			const [fingerPrintComponents, lookup] = await Promise.allSettled([
				fingerprint2.getPromise(config),
				axios.get(apiConfig.lookup),
			]);
			const values = fingerPrintComponents.value.map(component => component.value);
			const lookupValues = lookup.status === "fulfilled" ? Object.values(lookup.value.data) : [];

			resolve({
				values,
				hash: fingerprint2.x64hash128([...values, ...lookupValues].join(""), 64),
			});
		}, timingConfig.shortDelay);
	});
}
